export default __webpack_public_path__ + "0d87103784289fdbbf3f9f58434a2609.png";